import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import { filterStyleCompact } from 'embed/constants'

import AdvertiserDisclosure from 'embed/components/AdvertiserDisclosure'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { Product, PRODUCT_NAMES } from '@evenfinancial/even-ts-static'
import { DeepReadonly } from 'utility-types'
const Arrows = require('./arrows.svg')
const styles = require('./styles')

interface Props {
  availableProducts: DeepReadonly<Product[]>
  onApplicationStep: boolean
  onProductClick: (Product) => void
  onProductSelect: (e) => void
  selectedProduct?: Product
  viewportHeight?: number
  viewportWidth?: number
}

export const ProductPicker: React.FC<Props> = ({
  availableProducts,
  onApplicationStep,
  onProductClick,
  onProductSelect,
  selectedProduct,
}) => {
  const productTabs = (
    <ThemeConsumer>
      {({ colorBorder, colorPrimary, colorTextPrimary, fontFamilyPrimary }) => (
        <div className={styles.tabsContainer}>
          {filterStyleCompact() && <AdvertiserDisclosure />}
          {availableProducts.length > 1 ? (
            <ul data-test-id="navigation_tabs" className={styles.productPicker}>
              {availableProducts.map((product) => {
                const handleProductClick = () => onProductClick(product)
                return (
                  <li
                    key={product}
                    onClick={handleProductClick}
                    className={classnames(
                      styles.item,
                      css`
                        border-bottom-color: ${colorBorder};
                        color: ${colorTextPrimary};
                        font-family: ${fontFamilyPrimary};
                        &:hover {
                          color: ${colorPrimary};
                        }
                      `,
                      { [styles.active]: selectedProduct === product },
                      {
                        [css(
                          `
                      border-bottom-color: ${colorPrimary};
                      color: ${colorPrimary};
                      &:hover {
                        border-bottom-color: ${colorPrimary};
                        color: ${colorPrimary};
                      }
                      &:after {
                        border-top-color: ${colorPrimary};
                      }
                    `,
                        )]: selectedProduct === product,
                      },
                    )}
                  >
                    {PRODUCT_NAMES[product]}
                  </li>
                )
              })}
            </ul>
          ) : null}
        </div>
      )}
    </ThemeConsumer>
  )

  const productDropdown = (
    <ThemeConsumer>
      {({ colorPrimary, colorTextSecondary }) => (
        <>
          <div
            className={classnames(
              availableProducts.length > 1 ? styles.dropdownContainer : styles.dropdownContainerDisclosureOnly,
              css`
                color: ${colorTextSecondary};
              `,
            )}
          >
            {availableProducts.length > 1 ? <React.Fragment>Search for</React.Fragment> : null}
            {filterStyleCompact() && !onApplicationStep ? (
              <AdvertiserDisclosure className={styles.advertiserDisclosure} />
            ) : null}
          </div>
          {availableProducts.length > 1 ? (
            <div className={styles.productSelectContainer}>
              <select
                className={classnames(
                  styles.productSelect,
                  css`
                    border-color: ${colorPrimary};
                    color: ${colorPrimary};
                  `,
                )}
                onChange={onProductSelect}
                value={selectedProduct}
              >
                {availableProducts.map((product) => (
                  <option key={product} value={product}>
                    {PRODUCT_NAMES[product]}
                  </option>
                ))}
              </select>
              <div
                className={classnames(
                  styles.arrows,
                  css`
                    svg #chevron_right {
                      fill: ${colorPrimary};
                    }
                  `,
                )}
              >
                <Arrows />
              </div>
            </div>
          ) : null}
        </>
      )}
    </ThemeConsumer>
  )

  if (filterStyleCompact()) {
    return productDropdown
  } else {
    return productTabs
  }
}
